<template>
  <account-layout>
    <el-row :gutter="60">
      <el-col :span="24" class="row-space">
        <el-form :model="resetPassword" :rules="rules" ref="form">
          <el-form-item prop="password" label="New Password">
            <el-input v-model="resetPassword.password" type="password" class="input-space" placeholder="Type here..." />
          </el-form-item>
          <el-form-item prop="confirmPassword" label="Confirm New Password">
            <el-input v-model="resetPassword.confirmPassword" type="password" class="input-space" placeholder="Type here..." />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="row-space">
      <el-col :span="24">
        <el-button
          type="primary"
          class="ac-btn"
          @click="reset"
        >Reset Password</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="align-center">
        <el-button type="text" @click="login">Return to Login</el-button>
      </el-col>
    </el-row>
  </account-layout>
</template>

<script>
import _ from 'lodash';
import { errormsg } from '@/utils/constants';

import AccountLayout from './AccountLayout.vue';

export default {
  name: 'AccountReset',
  components: {
    AccountLayout
  },
  props: {
    platform: String
  },
  data() {
    const passwordRule = {
      required: true,
      trigger: 'blur',
      message: errormsg.password,
      validator: (r, value, c) => {
        let valid = true;
        if (!value) valid = false;
        // min length 8
        if (value && value.length <= 8) valid = false;
        // any upper case
        if (!_.some(value, (t) => t === t.toUpperCase())) valid = false;
        // any lower case
        if (!_.some(value, (t) => t === t.toLowerCase())) valid = false;
        // any special case
        if (!new RegExp('([`~\\!@#\\$%\\^\\&\\*\\(\\)\\-_\\=\\+\\[\\{\\}\\]\\\\|;:\\\'",<.>\\/\\?€£¥₹§±].*)').test(value)) valid = false;
        // not any space
        if (_.some(value, (t) => t === ' ')) valid = false;

        if (valid) return c();

        return c(new Error(errormsg.password));
      }
    };

    return {
      resetPassword: {
        password: undefined,
        confirmPassword: undefined
      },
      rules: {
        password: passwordRule,
        confirmPassword: passwordRule,
      }
    };
  },
  methods: {
    reset() {
      this.$refs.form.validate()
        .then((val) => {
          if (!val) return;
          const { token } = this.$route.params;
          if (!token) {
            this.$message.error('Invalid token');
            return;
          }

          if (this.resetPassword.password !== this.resetPassword.confirmPassword) {
            this.$message.error('The new password and confirmation password do not match');
            return;
          }

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$httpNoAuth.post(`assemble/api/v1/account/${this.platform}/reset/submit`, { hash: token, password: this.resetPassword.password })
            .then(() => {
              this.$message.success('You password has been changed successfully!');
              this.$store.commit('loading', false);
              this.$router.push('/login');
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        })
        .catch(() => {});
    },
    login() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped lang="scss">
.content-card {
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 2em;
  width: 90%;
  max-width: 30em;
}

.align-center {
  text-align: center;
}

.row-space {
  margin-top: 1em;
}

.input-space {
  margin-top: 0.5em;
}

.ac-btn {
  width: 100%;
  background-color: $highlight !important;
  border: 0;
}
</style>
